/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { action, makeObservable, observable } from 'mobx';

import { createBpmnModdle } from 'utils/web-modeler-diagram-parser/moddle-util';

import { convertConnectorId } from './utils';

export class DetectConnectorsStore {
  connectors = [];
  connectorElements = [];

  constructor() {
    makeObservable(this, {
      connectors: observable,
      connectorElements: observable,
      setConnectors: action,
      setConnectorElements: action
    });
  }

  setConnectors = (connectors) => {
    this.connectors = connectors;
  };

  setConnectorElements = (connectorElements) => {
    this.connectorElements = connectorElements;
  };

  detectConnectors = async (xml) => {
    const connectors = [];

    try {
      if (xml) {
        const bpmnModdle = createBpmnModdle();

        const { elementsById } = await bpmnModdle.fromXML(xml);

        Object.values(elementsById).forEach((element) => {
          const modelerTemplate = element.get('modelerTemplate');

          if (modelerTemplate) {
            const connector = convertConnectorId(modelerTemplate);

            if (connector && !connectors.includes(connector)) {
              connectors.push(connector);
            }
          }
        });
      }
    } catch (e) {
      console.info(e);
    }

    return connectors;
  };
}

export default new DetectConnectorsStore();
